import API from "shared/services/Api";
import { ICharacteristics } from "shared/types/Characteristics";

export const getCharacteristics = async (data: ICharacteristics) =>
  API.get(`oc/characteristics?id=${data.id}`);
